import React, {Fragment} from 'react';
import {IconButton, Stack, Typography} from '@mui/material';

import {CopySection} from 'presentation/components';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import {CopySectionMaskEnum} from 'presentation/constants';

import {Puller, StyledSwipeableDrawer} from './styles';
import {PhonesDrawerRootProps, PhonesDrawerWithTitleProps, PhonesDrawerSimpleProps} from './types';

const {copiedPhone} = translations['pt-br'].privateFlow.bookingFlow.unitsFlow.unitDetails;

function PhonesDrawerRoot({
	open,
	toggleDrawer,
	title,
	children,
	customPadding,
}: PhonesDrawerRootProps) {
	return (
		<StyledSwipeableDrawer
			anchor="bottom"
			open={open}
			onClose={toggleDrawer}
			onOpen={toggleDrawer}
			sx={{zIndex: 9000}}>
			<Stack py={2} alignItems="center">
				<Puller />
			</Stack>

			<Stack direction="row" px={2} justifyContent="space-between" alignItems="center">
				<Typography color="text.primary" variant="subtitle2" fontSize={20}>
					{title}
				</Typography>
				<IconButton onClick={toggleDrawer} edge="end">
					<Icon name="close-filled" size={24} />
				</IconButton>
			</Stack>

			<Stack gap={1.5} p={customPadding || 2} overflow="auto">
				{children}
			</Stack>
		</StyledSwipeableDrawer>
	);
}

function PhonesDrawerWithTitle({phoneNumbers, dataTagId}: PhonesDrawerWithTitleProps) {
	return (
		<Stack gap={1}>
			{phoneNumbers?.map(item => (
				<Stack key={item.title} gap={1} flex={1}>
					<Typography variant="caption">{item.title}</Typography>
					{item?.phones.map(phone => (
						<CopySection
							dataTagId={dataTagId}
							key={phone}
							value={phone}
							highlightedIcons
							callAction
							mask={CopySectionMaskEnum.WITHOUT_MASK}
							snackbarMessage={copiedPhone}
						/>
					))}
				</Stack>
			))}
		</Stack>
	);
}

function PhonesDrawerSimple({phoneNumbers, mask}: PhonesDrawerSimpleProps) {
	return (
		<Fragment>
			{phoneNumbers?.map(item => (
				<CopySection
					mask={mask}
					key={item}
					value={item}
					highlightedIcons
					callAction
					snackbarMessage={copiedPhone}
				/>
			))}
		</Fragment>
	);
}

export const PhonesDrawer = {
	Root: PhonesDrawerRoot,
	WithTitle: PhonesDrawerWithTitle,
	Simple: PhonesDrawerSimple,
};
